module.exports = __webpack_public_path__ + "img/pessoas-monitoradas.3b4045c9.svg";